<template>
  <div>
    <users-receive-card profile/>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { useStore } from "vuex";
import { computed, onMounted, onUpdated, nextTick } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import UsersReceiveCard from "@/components/UsersReceiveCard.vue";

export default {
  name: "Profile",
  components: {UsersReceiveCard},
  setup() {
    const store = useStore();
    useCommonMixin();
    const { isDeliverer, isReceiver, isAdmin, isManager, isWholesaler } = useCommonMixin();

    onMounted(async () => {});

    return {
      isDeliverer,
      isReceiver,
      isAdmin,
      isManager,
      isWholesaler
    };
  }
};
</script>

<style></style>
